import { OrderedSet, Map } from 'immutable';

import * as types from './types';
import { sortTestCases, filterTestCases } from './utils';

const initialState = Map({
  loadingData: true,
  pagination: Map({
    size: 10,
    activePage: 0,
  }),
  testCases: OrderedSet(),
  testCasesCount: 0,
  sort: Map({
    field: 'total_runs',
    isDescending: true,
  }),
});

const testListReducer = (state = initialState, { type, payload, meta }) => {
  switch (type) {
    case types.CHANGE_PAGINATION:
      return state.set('pagination', payload || initialState.get('pagination'));
    case types.GET_TEST_CASES.REQUEST:
      return state.set('loadingData', true);
    case types.GET_TEST_CASES.SUCCESS:
      return state.withMutations((newState) => {
        const testCases = OrderedSet(filterTestCases(payload.items, meta.status));
        const sortedTestCases = sortTestCases(
          testCases, state.getIn(['sort', 'field']), state.getIn(['sort', 'isDescending']),
        );
        newState
          .set('testCases', sortedTestCases)
          .set('loadingData', false)
          .set('testCasesCount', testCases.size);
      });
    case types.GET_TEST_CASES.FAILURE:
      return state.set('loadingData', false);
    case types.SORT_TEST_CASES: {
      return state.withMutations((newState) => {
        const sortedTestCases = sortTestCases(state.get('testCases'), payload.sortField, payload.sortDescending);
        newState
          .set('testCases', sortedTestCases)
          .setIn(['sort', 'field'], payload.sortField)
          .setIn(['sort', 'isDescending'], payload.sortDescending);
      });
    }
    case types.CLEANUP_TEST_LIST:
      return initialState;
    default:
      return state;
  }
};

export default testListReducer;
export { initialState };
